export const EVENT_SCROLL_LOCK_ON_DISABLE_START = 'scrollLockOnDisableStart';
export const EVENT_SCROLL_LOCK_ON_DISABLE = 'scrollLockOnDisable';
export const EVENT_SCROLL_LOCK_ON_ENABLE_START = 'scrollLockOnEnableStart';
export const EVENT_SCROLL_LOCK_ON_ENABLE = 'scrollLockOnEnable';
